import React from 'react';
import PropTypes from 'prop-types';

import {imageUrl} from '../../utilities/requests';


export default class Review extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    render() { 
        if (this.props.is_virtual) {
            return <div>
            <div
                style={{
                    float: 'right',
                    width: '40%',
                    height: '100%',
                    borderLeft: '.125em solid #cacaca',
                    boxSizing: 'border-box',
                }}>
                <div
                    style={{
                        marginRight: '.5em',
                        marginTop: '.5em',
                        marginBottom: '-.25em',
                        fontSize: '1.1em',
                        position: 'relative',
                    }}>
                    <i
                        style={{color: this.props.sections[0].passed ? 'green' : 'red'}}
                        className={`fa fa-${this.props.sections[0].passed ? 'check' : 'times'} fa-lg`}>
                    </i>
                    &nbsp;
                    {window.gettext('Cart')}
                    <i
                        style={{
                            position: 'absolute',
                            left: '20%',
                            top: '50%',
                            transform: 'translateY(-50%)',
                        }}
                        className='fa-shopping-basket fa-lg'>
                    </i>
                </div>
                <hr style={{borderTop: '.125em solid #cacaca', width: '80%', marginRight: '0'}}/>
                <div style={{padding: '.5em', maxHeight: 'calc(100% - 7em)', overflowY: 'auto'}}>
                    {this.props.items.sortBy(item => item.get('timestamp')).map(
                        (item, index) => [
                            <div
                                key={item.getIn(['item', 'id'])}
                                style={{
                                    overflow: 'hidden',
                                    padding: '.5em',
                                    ...((Date.now() - item.get('editTimestamp')) < 1200
                                        ? {backgroundColor: 'rgb(100, 210, 100)'}
                                        : {}
                                    ),
                                }}>
                                <img
                                    style={{
                                        width: '3em',
                                        height: '4em',
                                        verticalAlign: 'top',
                                        marginRight: '.5em',
                                        marginLeft: '.5em',
                                        float: 'right',
                                    }}
                                    src={imageUrl(item.getIn(['item', 'final_image']), {
                                        width: 48,
                                        height: 64,
                                        type: 'cover',
                                    })}
                                />
                                <div style={{float: 'right', fontSize: '.9em', width: 'calc(100% - 4.75em/.9)'}}>
                                    <div style={{width: '100%', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                        {item.getIn(['item', 'caption'])}
                                    </div>
                                    <div style={{fontSize: '.85em'}}>
                                        {window.gettext('Count')}: {item.get('count').persian()}
                                    </div>
                                    <div style={{fontSize: '.85em'}}>
                                        {window.gettext('Price')}:&nbsp;
                                        {(item.getIn(['item', 'price'])
                                            ? (item.getIn(['item', 'price']) - (item.getIn(['item', 'price']) * item.getIn(['item', 'off']) / 100)) * item.get('count')
                                            : '-'
                                        ).persian()} {window.gettext('Tooman')}
                                    </div>
                                </div>
                            </div>,
                            index < this.props.items.size - 1
                                ? <hr style={{width: '14em', marginRight: '0'}}/>
                                : null,
                        ]
                    ).toArray()}
                </div>
                <div style={{padding: '.5em', marginTop: '.125em'}}>
                    {window.gettext('Total Price')}:&nbsp;
                    <span style={{fontWeight: '800'}}>
                        {this.props.items.reduce(
                            (sum, item) => sum + (item.getIn(['item', 'price']) - (item.getIn(['item', 'price']) * item.getIn(['item', 'off']) / 100)) * item.get('count'),
                            0,
                        ).persian()} {window.gettext('Tooman')}
                    </span>
                    &nbsp;
                    <span style={{fontSize: '.8em'}}>
                        ({this.props.items.reduce(
                            (sum, item) => sum + item.get('count'),
                            0,
                        ).persian()} {window.pgettext('cart', 'Items')})
                    </span>
                </div> 
            </div>
            <div
                style={{
                    float: 'right',
                    width: '60%',
                }}>  

<div
                    style={{
                        marginRight: '.5em',
                        marginTop: '.5em',
                        marginBottom: '-.25em',
                        fontSize: '1.1em',
                        position: 'relative',
                    }}>
                    <i
                        style={{color: this.props.sections[1].passed ? 'green' : 'red'}}
                        className={`fa fa-${this.props.sections[1].passed ? 'check' : 'times'} fa-lg`}>
                    </i>
                    &nbsp;
                    اطلاعات تکمیلی
                    <i
                        style={{
                            position: 'absolute',
                            left: '20%',
                            top: '50%',
                            transform: 'translateY(-50%)',
                        }}
                        className='fa-envelope-o fa-lg'>
                    </i>
                </div>
                <hr style={{borderTop: '.125em solid #cacaca', width: '80%', marginRight: '0'}}/>
                <div style={{margin: '.5em'}}>  
                    <span style={{color: '#9a9a9a'}}>{window.gettext('City')}:</span>&nbsp;
                    <span style={{color: '#2a2a2a'}}>{(this.props.store.getIn(['info', 'city_display']) || '-').persian()}</span>
                    <br/> 
                    <div style={{height: '3em'}}>
                        <span style={{color: '#9a9a9a'}}>مدرسه:</span>&nbsp;
                        <span style={{color: '#2a2a2a'}}>{(this.props.store.getIn(['info', 'address']) || '-').persian()}</span>
                    </div>
                </div>

                <div
                    style={{
                        marginRight: '.5em',
                        marginTop: '.5em',
                        marginBottom: '-.25em',
                        fontSize: '1.1em',
                        position: 'relative',
                    }}>
                    <i
                        style={{color: this.props.sections[3].passed ? 'green' : 'red'}}
                        className={`fa fa-${this.props.sections[3].passed ? 'check' : 'times'} fa-lg`}>
                    </i>
                    &nbsp;
                    {window.gettext('Payment Method')}
                    <i
                        style={{
                            position: 'absolute',
                            left: '20%',
                            top: '50%',
                            transform: 'translateY(-50%)',
                        }}
                        className='fa-credit-card fa-lg'>
                    </i>
                </div>
                <hr style={{borderTop: '.125em solid #cacaca', width: '80%', marginRight: '0'}}/>
                <div style={{margin: '.5em'}}>
                    {this.props.store.get('payment_method') !==null
                        ? {
                            0: window.gettext('Bank gateway'),
                            1: window.gettext('Draft'),
                            2: window.gettext('No Payment / Free'),
                            3: window.gettext('Debtor'),
                        }[this.props.store.get('payment_method')]
                        : 'لطفا روش پرداخت را مشخص کنید'
                    }
                </div>
            </div>
        </div>;  
        }
        else{
            return <div>
            <div
                style={{
                    float: 'right',
                    width: '40%',
                    height: '100%',
                    borderLeft: '.125em solid #cacaca',
                    boxSizing: 'border-box',
                }}>
                <div
                    style={{
                        marginRight: '.5em',
                        marginTop: '.5em',
                        marginBottom: '-.25em',
                        fontSize: '1.1em',
                        position: 'relative',
                    }}>
                    <i
                        style={{color: this.props.sections[0].passed ? 'green' : 'red'}}
                        className={`fa fa-${this.props.sections[0].passed ? 'check' : 'times'} fa-lg`}>
                    </i>
                    &nbsp;
                    {window.gettext('Cart')}
                    <i
                        style={{
                            position: 'absolute',
                            left: '20%',
                            top: '50%',
                            transform: 'translateY(-50%)',
                        }}
                        className='fa-shopping-basket fa-lg'>
                    </i>
                </div>
                <hr style={{borderTop: '.125em solid #cacaca', width: '80%', marginRight: '0'}}/>
                <div style={{padding: '.5em', maxHeight: 'calc(100% - 7em)', overflowY: 'auto'}}>
                    {this.props.items.sortBy(item => item.get('timestamp')).map(
                        (item, index) => [
                            <div
                                key={item.getIn(['item', 'id'])}
                                style={{
                                    overflow: 'hidden',
                                    padding: '.5em',
                                    ...((Date.now() - item.get('editTimestamp')) < 1200
                                        ? {backgroundColor: 'rgb(100, 210, 100)'}
                                        : {}
                                    ),
                                }}>
                                <img
                                    style={{
                                        width: '3em',
                                        height: '4em',
                                        verticalAlign: 'top',
                                        marginRight: '.5em',
                                        marginLeft: '.5em',
                                        float: 'right',
                                    }}
                                    src={imageUrl(item.getIn(['item', 'final_image']), {
                                        width: 48,
                                        height: 64,
                                        type: 'cover',
                                    })}
                                />
                                <div style={{float: 'right', fontSize: '.9em', width: 'calc(100% - 4.75em/.9)'}}>
                                    <div style={{width: '100%', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                        {item.getIn(['item', 'caption'])}
                                    </div>
                                    <div style={{fontSize: '.85em'}}>
                                        {window.gettext('Count')}: {item.get('count').persian()}
                                    </div>
                                    <div style={{fontSize: '.85em'}}>
                                        {window.gettext('Price')}:&nbsp;
                                        {(item.getIn(['item', 'price'])
                                            ? (item.getIn(['item', 'price']) - (item.getIn(['item', 'price']) * item.getIn(['item', 'off']) / 100)) * item.get('count')
                                            : '-'
                                        ).persian()} {window.gettext('Tooman')}
                                    </div>
                                </div>
                            </div>,
                            index < this.props.items.size - 1
                                ? <hr style={{width: '14em', marginRight: '0'}}/>
                                : null,
                        ]
                    ).toArray()}
                </div>
                
                <div style={{padding: '.5em', marginTop: '.125em'}}>
                    {window.gettext('Total Price')}:&nbsp;
                    <span style={{fontWeight: '800'}}>
                        {this.props.items.reduce(
                            (sum, item) => sum + (item.getIn(['item', 'price']) - (item.getIn(['item', 'price']) * item.getIn(['item', 'off']) / 100)) * item.get('count'),
                            0,
                        ).persian()} {window.gettext('Tooman')}
                    </span>
                    &nbsp;
                    <span style={{fontSize: '.8em'}}>
                        ({this.props.items.reduce(
                            (sum, item) => sum + item.get('count'),
                            0,
                        ).persian()} {window.pgettext('cart', 'Items')})
                    </span>
                </div>
                <div style={{padding: '.5em'}}>
                    {window.gettext('Total Weight')}:&nbsp;
                    <span style={{fontWeight: '800'}}>
                        {this.props.weight.persian()} {window.gettext('KG')}
                    </span>
                </div>
            </div>
            <div
                style={{
                    float: 'right',
                    width: '60%',
                }}>
                <div
                    style={{
                        marginRight: '.5em',
                        marginTop: '.5em',
                        marginBottom: '-.25em',
                        fontSize: '1.1em',
                        position: 'relative',
                    }}>
                    <i
                        style={{color: this.props.sections[1].passed ? 'green' : 'red'}}
                        className={`fa fa-${this.props.sections[1].passed ? 'check' : 'times'} fa-lg`}>
                    </i>
                    &nbsp;
                    {window.gettext('Recipient Info')}
                    <i
                        style={{
                            position: 'absolute',
                            left: '20%',
                            top: '50%',
                            transform: 'translateY(-50%)',
                        }}
                        className='fa-envelope-o fa-lg'>
                    </i>
                </div>
                <hr style={{borderTop: '.125em solid #cacaca', width: '80%', marginRight: '0'}}/>
                <div style={{margin: '.5em'}}>
                    <span style={{color: '#9a9a9a'}}>{window.gettext('Firstname')}:</span>&nbsp;
                    <span style={{color: '#2a2a2a'}}>
                        {(this.props.store.getIn(['info', 'firstname']) || '').persian()} {(this.props.store.getIn(['info', 'lastname']) || '').persian()}
                    </span>
                    <br/>
                    <span style={{color: '#9a9a9a'}}>{window.gettext('Cell phone')}:</span>&nbsp;
                    <span style={{color: '#2a2a2a'}}>{(this.props.store.getIn(['info', 'cell_phone']) || '-').persian()}</span>
                    <br/>
                    <span style={{color: '#9a9a9a'}}>{window.gettext('Phone')}:</span>&nbsp;
                    <span style={{color: '#2a2a2a'}}>{(this.props.store.getIn(['info', 'phone']) || '-').persian()}</span>
                    <br/>
                    <span style={{color: '#9a9a9a'}}>{window.gettext('Region')}:</span>&nbsp;
                    <span style={{color: '#2a2a2a'}}>{(this.props.store.getIn(['info', 'region_display']) || '-').persian()}</span>
                    <br/>
                    <span style={{color: '#9a9a9a'}}>{window.gettext('City')}:</span>&nbsp;
                    <span style={{color: '#2a2a2a'}}>{(this.props.store.getIn(['info', 'city_display']) || '-').persian()}</span>
                    <br/>
                    <span style={{color: '#9a9a9a'}}>{window.gettext('Postal Code')}:</span>&nbsp;
                    <span style={{color: '#2a2a2a'}}>{(this.props.store.getIn(['info', 'postal_code']) || '-').persian()}</span>
                    <br/>
                    <div style={{height: '3em'}}>
                        <span style={{color: '#9a9a9a'}}>{window.gettext('Address')}:</span>&nbsp;
                        <span style={{color: '#2a2a2a'}}>{(this.props.store.getIn(['info', 'address']) || '-').persian()}</span>
                    </div>
                </div>

                <div
                    style={{
                        marginRight: '.5em',
                        marginTop: '.5em',
                        marginBottom: '-.25em',
                        fontSize: '1.1em',
                        position: 'relative',
                    }}>
                    <i
                        style={{color: this.props.sections[2].passed ? 'green' : 'red'}}
                        className={`fa fa-${this.props.sections[2].passed ? 'check' : 'times'} fa-lg`}> 
                    </i>
                    &nbsp;
                    {window.gettext('Delivery Method')}
                    <i
                        style={{
                            position: 'absolute',
                            left: '20%',
                            top: '50%',
                            transform: 'translateY(-50%)',
                        }}
                        className='fa-truck fa-lg'>
                    </i>
                </div>
                <hr style={{borderTop: '.125em solid #cacaca', width: '80%', marginRight: '0'}}/>
                <div style={{margin: '.5em'}}>
                    {this.props.store.get('delivery_method') !== null
                        ? <span>
                            {{
                                // 0: window.gettext('Bespoke Post'),
                                // 1: window.gettext('Pishtaz Post'),
                                1 : window.gettext('Post Delivery'),
                                // 2: window.gettext('Transportation'),
                                // 3: window.gettext('Terminal'),
                            }[this.props.store.get('delivery_method')]}
                            &nbsp;-&nbsp;
                            <span style={{fontWeight: '700'}}>
                                {(this.props.deliveryPrices[this.props.store.get('delivery_method')]
                                    ? this.props.deliveryPrices[this.props.store.get('delivery_method')].persian() + ' ' + window.gettext('Tooman')
                                    : window.gettext('Free')
                                )}
                            </span>
                        </span>
                        : '-'
                    }
                </div>
                <div
                    style={{
                        marginRight: '.5em',
                        marginTop: '.5em',
                        marginBottom: '-.25em',
                        fontSize: '1.1em',
                        position: 'relative',
                    }}>
                    <i
                        style={{color: this.props.sections[3].passed ? 'green' : 'red'}}
                        className={`fa fa-${this.props.sections[3].passed ? 'check' : 'times'} fa-lg`}>
                    </i>
                    &nbsp;
                    {window.gettext('Payment Method')}
                    <i
                        style={{
                            position: 'absolute',
                            left: '20%',
                            top: '50%',
                            transform: 'translateY(-50%)',
                        }}
                        className='fa-credit-card fa-lg'>
                    </i>
                </div>
                <hr style={{borderTop: '.125em solid #cacaca', width: '80%', marginRight: '0'}}/>
                <div style={{margin: '.5em'}}>
                    {this.props.store.get('payment_method') !== null
                        ? {
                            0: window.gettext('Bank gateway'),
                            1: window.gettext('Draft'),
                            2: window.gettext('No Payment / Free'),
                            3: window.gettext('Debtor'),
                        }[this.props.store.get('payment_method')]
                        : '-'
                    }
                </div>
            </div>
        </div>;
        }

        
    }
}
